import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase';

function CategoriesSelector({categories, setCategories}) {

    const [postCategories, setPostCategories] = useState([]);
    const [categoryIds, setCategoryIds] = useState([])

    useEffect(() => {

        try {
            const categoriesRef = firestore.collection("football-blogs-categories");
            categoriesRef.orderBy("category").onSnapshot(({docs}) => {
                const postCategories = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setPostCategories(postCategories);
            })
        } catch (error) {
        }

    }, [])

    useEffect(() => {

        if (categories) {
            console.log(categories)
            const categoryIds = categories.map(category => {
                
                return category.id;
            })
            setCategoryIds(categoryIds)
            console.log(categoryIds)
           
        }

    }, [categories])

    function categoriesHandler(category) {

        if (categories) {

            if (categoryIds.includes(category.id)) {
                const newCategories = categories.filter(newCategory => {
                    return newCategory.id !== category.id
                })
                setCategories(newCategories)
            } else {
                let newCategories = categories.concat(category)
                setCategories(newCategories);
            }


        } else {
            setCategories([category])
        }

    }

    return (
        <div>
            {postCategories?.map((category, index) => {
                return (
                    <div 
                        style={{cursor: "pointer"}} 
                        onClick={() => categoriesHandler(category)} 
                        key={index}
                        className={categoryIds.includes(category.id) ? "text-success" : ""}
                    >
                        <i className={categoryIds.includes(category.id) ? "fas fa-check" : "fas fa-circle text-light"}></i> {category.category}
                    </div>
                )
            })}
        </div>
    )

}
export default CategoriesSelector